import type { UserAudience } from 'hooks/user'
import { getRobotTypeFullDisplayName } from 'utils/robotTypeDisplayName'
import { VENDOR, type VendorCode } from 'utils/vendorDisplayName'

export const SERVICE_REPORT_FILLOUT_ID = '4K8K1m11Wbus'
export const SERVICE_REPORT_DOMAIN = 'forms.autonomics.tech'

export type ServiceReportParameters = {
  SN: string
  ServiceEngineer: string
  RobotModel: string
}

export const canSeeServiceReport = (input: {
  audience: UserAudience | null
  vendor?: VendorCode | string | null
}): boolean =>
  (input.audience === 'serviceman' ||
    input.audience === 'internal_serviceman' ||
    input.audience === 'fleet_ops') &&
  (input.vendor === VENDOR.AUTONOMICS || input.vendor === VENDOR.GAUSIUM)

export function buildServiceReportParameters(input: {
  serialNumber?: string | null
  robotType?: string | null
  robotTypeDisplay?: string | null
  vendor?: VendorCode | string | null
  firstName?: string | null
  lastName?: string | null
}): ServiceReportParameters {
  const serviceEngineer = [input.firstName, input.lastName].filter(Boolean).join(' ').trim()
  const robotModel =
    getRobotTypeFullDisplayName(input.vendor || undefined, input.robotType) ||
    (input.robotTypeDisplay || '').trim() ||
    (input.robotType || '').trim()

  return {
    SN: (input.serialNumber || '').trim(),
    ServiceEngineer: serviceEngineer,
    RobotModel: robotModel,
  }
}
